import React from 'react';
import styles from './BackButton.module.scss';

interface BackButtonSimpleProps {
  goBack?: () => void;
  img?: string;
}

const BackButtonSimple: React.FC<BackButtonSimpleProps> = ({ goBack, img }) => (
  <div
    className={styles.BackButtonSimple}
    onClick={goBack}
    data-cy="modal-back-button"
  >
    <img src={`/img/buttons/${img}.svg`} alt="" />
  </div>
);

export default BackButtonSimple;
